export const FONT_WEIGHTS = {
  lightExtra: 200,
  regular: 400,
  medium: 500,
  boldSemi: 600,
  bold: 700,
  boldExtra: 800,
} as const
